var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "colored",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9292 24C24.9292 20.134 28.0632 17 31.9292 17H45.9292C49.7952 17 52.9292 20.134 52.9292 24V48.5C52.9292 52.366 49.7952 55.5 45.9292 55.5H31.9292C28.0632 55.5 24.9292 52.366 24.9292 48.5V24Z",
    fill: "#FFC100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9292 18.25H45.9292V15.75H31.9292V18.25ZM51.6792 24V48.5H54.1792V24H51.6792ZM45.9292 54.25H31.9292V56.75H45.9292V54.25ZM26.1792 48.5V24H23.6792V48.5H26.1792ZM31.9292 54.25C28.7536 54.25 26.1792 51.6756 26.1792 48.5H23.6792C23.6792 53.0564 27.3729 56.75 31.9292 56.75V54.25ZM51.6792 48.5C51.6792 51.6756 49.1048 54.25 45.9292 54.25V56.75C50.4855 56.75 54.1792 53.0564 54.1792 48.5H51.6792ZM45.9292 18.25C49.1048 18.25 51.6792 20.8244 51.6792 24H54.1792C54.1792 19.4437 50.4855 15.75 45.9292 15.75V18.25ZM31.9292 15.75C27.3729 15.75 23.6792 19.4437 23.6792 24H26.1792C26.1792 20.8244 28.7536 18.25 31.9292 18.25V15.75Z",
    fill: "#FFC100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9292 51.25C32.2388 51.25 31.6792 51.8096 31.6792 52.5C31.6792 53.1904 32.2388 53.75 32.9292 53.75V51.25ZM32.9467 53.75C33.637 53.75 34.1967 53.1904 34.1967 52.5C34.1967 51.8096 33.637 51.25 32.9467 51.25V53.75ZM32.9292 53.75H32.9467V51.25H32.9292V53.75ZM25.9292 24H39.9292V21.5H25.9292V24ZM45.6792 29.75V54.25H48.1792V29.75H45.6792ZM39.9292 60H25.9292V62.5H39.9292V60ZM20.1792 54.25V29.75H17.6792V54.25H20.1792ZM25.9292 60C22.7536 60 20.1792 57.4256 20.1792 54.25H17.6792C17.6792 58.8064 21.3729 62.5 25.9292 62.5V60ZM45.6792 54.25C45.6792 57.4256 43.1048 60 39.9292 60V62.5C44.4855 62.5 48.1792 58.8064 48.1792 54.25H45.6792ZM39.9292 24C43.1048 24 45.6792 26.5744 45.6792 29.75H48.1792C48.1792 25.1937 44.4855 21.5 39.9292 21.5V24ZM25.9292 21.5C21.3729 21.5 17.6792 25.1937 17.6792 29.75H20.1792C20.1792 26.5744 22.7536 24 25.9292 24V21.5Z",
    fill: "#131416"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9965 9.45967L23.3838 13.9005",
    stroke: "#FA4364",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.771 11.7525L18.6679 15.4227",
    stroke: "#FA4364",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3477 19.973L15.939 19.7246",
    stroke: "#FA4364",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.39fd9a76.svg";
export { ForwardRef as ReactComponent };